import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Shield = props => {

    const { bckgColor, name, slug, urlAssets } = props;

    return (
        <section className="mb-3 pb-2 text-center" style={{ backgroundColor: bckgColor }}>
            <LazyLoadImage
                alt={name}
                className="img-fluid"
                effect="blur"
                src={`${urlAssets}/img/selecciones-datos/${slug}/escudo.png`}
            />
            <h1 className="my-3 text-white team-name">{name}</h1>
        </section>
    )
}

export default Shield;

Shield.propTypes = {
    bckgColor: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired
}
